export const PARTICIPANT_STATUS_ACTIVE = 1;
export const PARTICIPANT_STATUS_PENDING = 2;
export const PARTICIPANT_STATUS_REJECTED = 3;